<app-single-selection-list-modal
  [id]="'select-space-dialog'"
  [title]="'Select Space' | translate"
  [searchPlaceholder]="'Search for Spaces' | translate"
  [sections]="{
    columns,
    disclaimer: user?.institution ? disclaimer : null,
    footer: !hideFooter ? footer : null
  }"
  [fetchConfig]="fetchConfig"
  [emptyMessage]="'No Spaces found' | translate"
>
  <ng-template #disclaimer>
    <ng-container *ngIf="!isSitesEnabled || !site; else sitesDisclaimer">
      {{ 'Only showing Spaces in your institution.' | translate }}
    </ng-container>
    <ng-template #sitesDisclaimer>
      {{ 'Only showing Spaces associated with' | translate }}
      <span class="site-name">{{ site?.name }}.</span>
      <a
        [href]="LEARN_MORE_ABOUT_SITES"
        data-name="select-space-dialog-learn-more"
        target="_blank"
        class="learn-more"
      >
        {{ ' Learn more' | translate }}
      </a>
    </ng-template>
  </ng-template>

  <ng-template #nameHeader>{{ 'Name' | translate }}</ng-template>
  <ng-template #nameCell let-space>
    <span class="text-ellipsis">{{ space.title }}</span>
  </ng-template>

  <ng-template #ownerHeader>{{ 'Owner' | translate }}</ng-template>
  <ng-template #ownerCell let-space>
    <app-profile-photo [user]="space.owner" [width]="26" [showName]="true"></app-profile-photo>
  </ng-template>

  <ng-template #footer>
    <div class="footer-content">
      <span>{{ 'Select a Space from above or' | translate }}</span>
      <button
        mat-flat-button
        data-name="select-space-dialog-create-space"
        [disabled]="!canCreateSpace"
        [appTooltip]="'You do not have permission to create a Space' | translate"
        [appTooltipArrow]="'bottom'"
        [appTooltipDisabled]="canCreateSpace"
        (click)="showCreateSpaceDialog()"
      >
        <span class="material-icons">add</span>
        <span>{{ 'Create Space' | translate }}</span>
      </button>
    </div>
  </ng-template>
</app-single-selection-list-modal>
